import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'

const AutocompleteFilter = (props) => {
  const {
    label,
    options,
    onChange,
    filterList,
    index,
    column,
    style,
    filterName,
    getOptionLabel,
    noOptionsText = 'No se encontraron resultados',
    fullWidth,
    defaultOption = null,
    placeholder = 'Seleccionar...',
  } = props

  const effectiveFilterName = filterName || 'name'

  const safeOptions = Array.isArray(options) ? options : []
  const safeFilterList = Array.isArray(filterList) ? filterList : []
  const currentFilter = Array.isArray(safeFilterList[index]) ? safeFilterList[index] : []

  const selectedValue = (() => {
    if (currentFilter.length > 0) {
      const raw = currentFilter[0]
      const found = safeOptions.find((opt) => opt && opt[effectiveFilterName] === raw)
      return found || { [effectiveFilterName]: raw }
    }
    return defaultOption || null
  })()

  return (
    <Autocomplete
      fullWidth={fullWidth}
      disableClearable
      getOptionSelected={(option, value) => {
        if (!option || !value) return false
        if (option.id !== undefined && value.id !== undefined) return option.id === value.id
        return option[effectiveFilterName] === value[effectiveFilterName]
      }}
      getOptionLabel={(option) => {
        if (!option) return ''
        // eslint-disable-next-line
        return getOptionLabel ? eval(getOptionLabel) : option?.[effectiveFilterName]
      }}
      style={style}
      options={safeOptions}
      noOptionsText={noOptionsText}
      openText="Abrir"
      closeText="Cerrar"
      clearText="Borrar"
      value={selectedValue}
      onChange={(event, value) => {
        const nextValue = value ? value[effectiveFilterName] : ''
        safeFilterList[index] = nextValue ? [nextValue] : []
        onChange(safeFilterList[index], index, column)
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          // className={style}
          margin="normal"
          label={label}
          placeholder={selectedValue ? '' : placeholder}
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
    />
  )
}

export default AutocompleteFilter
